import React from "react";
import classNames from "classnames";
import { TEXT_CLASS_NAME } from "../Text";
import styles from "./Callout.module.scss";

type Props = {
  as?: keyof JSX.IntrinsicElements;
  href?: string;
  target?: string;
  rel?: string;
  disabled?: boolean;
  className?: string;
} & React.HTMLAttributes<HTMLOrSVGElement>;

const Callout = ({ as: As = "p", className, ...props }: Props) => (
  <As
    {...props}
    className={classNames(TEXT_CLASS_NAME, styles.callout, className)}
  />
);

export default Callout;
